import { useLayoutEffect } from 'react';
import { useLocation } from 'react-router-dom';

/**
 * Scrolls the window to the top on client-side navigation (React Router).
 */
export function ScrollToTop() {
  const { pathname } = useLocation();

  useLayoutEffect(() => {
    try {
      // Remember where the user was before opening /feedback.
      if (pathname && pathname !== '/feedback') {
        window.sessionStorage.setItem('lq:last_path', pathname);
        window.sessionStorage.setItem('lq:last_href', window.location.href);
      }
    } catch {
      // Ignore storage errors (private mode, disabled storage, etc.)
    }
    window.scrollTo(0, 0);
  }, [pathname]);

  return null;
}
